export class Keys {
    static ACCOUNT_KEY = "RiddletagAccountKey";
    static AUTHORIZATION_TOKEN = "RiddletagAuthorizationToken";
    static INITIALS = "RiddletagUserInitials";
    static EMAIL = "RiddletagUserEmail"
}

export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/;

